import {
  booleanAttribute,
  Component,
  computed,
  input,
  OnInit,
  effect,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { CurrencyUtil } from 'app/core/utils/currency.utils';
import { PhysicianProcedure } from '../../../../core/dtos/physician.dto';

@Component({
  selector: 'app-physician-procedure-item',
  templateUrl: './physician-procedure-item.component.html',
  styleUrl: './physician-procedure-item.component.scss',
  host: {
    class: 'flex w-full justify-between items-center py-4',
  },
})
export class PhysicianProcedureItemComponent implements OnInit {
  procedure = input.required<PhysicianProcedure>();
  toogleSelectProcedure =
    input.required<(procedureSelected: PhysicianProcedure) => void>();
  isSelected = input(false, { transform: booleanAttribute });
  procedureName = computed(() => this.procedure().procedureName);
  originalPrice = computed(() =>
    CurrencyUtil.convertToBrazilianCurrency(
      +this.procedure().procedureOriginalPrice,
    ),
  );
  discountInPercent = computed(() =>
    this.procedure().procedureDiscontPercent.toFixed(2),
  );
  finalPrice = computed(() =>
    CurrencyUtil.convertToBrazilianCurrency(
      this.procedure().procedureFinalPriceWithTax,
    ),
  );
  selected = new FormControl(false);

  constructor() {
    effect(() => {
      this.selected.setValue(this.isSelected(), { emitEvent: false });
    });
  }

  ngOnInit(): void {
    this.selected.setValue(this.isSelected());

    this.selected.valueChanges.subscribe(() => {
      this.toogleSelectProcedure()(this.procedure());
    });
  }
}
